const MdGlowButton = ({
  children,
  href,
  className = "",
  wrapClassName = "mt-6",
  variant = "default",
  type = "button",
  ...props
}) => {
  const variantClass = variant === "success" ? "md-btn-glow--success" : "";
  const inner = <span className="md-btn-glow-text">{children}</span>;

  const control = href ? (
    <a href={href} className={`md-btn-glow ${variantClass} ${className}`.trim()}>
      {inner}
    </a>
  ) : (
    <button type={type} className={`md-btn-glow ${variantClass} ${className}`.trim()} {...props}>
      {inner}
    </button>
  );

  return <div className={`md-btn-wrap ${wrapClassName}`.trim()}>{control}</div>;
};

export default MdGlowButton;
